import * as server from "@/utils/http"

export const _page = params => server.get("/physical-packages/page", params);

export const _get = params => server.get("/physical-packages/get", params);

export const _save = params => server.post(params.id ? "/physical-packages/update" : "/physical-packages/save", params);

export const _updateStatus = params => server.get("/physical-packages/updateStatus", params);

export const _packagesName = params => server.get("/physical-packages/packages-name", params);

export const _packagesList = params => server.get("/physical-packages/list", params);

export const _packagesTaskId = params => server.get("/physical-packages/packages-taskId", params);

